import { Fragment, useEffect, useState } from 'react';

import clsx from 'clsx';

import { BaseButton } from 'components/Button';
import Icon from 'components/Icon';
import Paper from 'components/Paper';
import Typography from 'components/Typography';
import { useEventContext } from 'context/EventContext';
import { useTransition } from 'hooks';

import { PROFILE_LINKS, getProfileLinkDestination } from '../../constants';

import classes from './Menu.module.scss';

const Menu = ({ handleClose }) => {
  const { addEvent } = useEventContext();
  const [isOpen, setIsOpen] = useState(true);
  const { stage, shouldMount } = useTransition(isOpen, 200);

  useEffect(() => {
    const onClose = () => {
      setIsOpen(false);
      setTimeout(() => {
        handleClose();
      }, 200);
    };
    window.addEventListener('click', onClose);

    return () => {
      window.removeEventListener('click', onClose);
    };
  }, [handleClose]);

  return (
    shouldMount && (
      <div className={clsx('Menu', classes.menu, classes[stage])}>
        <Paper className={classes.paper}>
          {Object.values(PROFILE_LINKS).map((link, index, links) => (
            <Fragment key={link.label}>
              {index > 0 && link.group !== links[index - 1].group && (
                <div aria-hidden="true" className={classes.divider} />
              )}
              <BaseButton
                component="button"
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  window.location.assign(getProfileLinkDestination(link));
                }}
                {...addEvent({ name: 'engagement_navigation', ...link.event })}
              >
                {link.icon && (
                  <Icon className={classes.icon} icon={link.icon} size="20" />
                )}
                <Typography component="span" variant="body-sm">
                  {link.label}
                </Typography>
              </BaseButton>
            </Fragment>
          ))}
        </Paper>
      </div>
    )
  );
};

export default Menu;
